export default function BacktestPage() {
  return (
    <main
      className="min-h-screen px-6"
      style={{ background: '#F8FAFC', paddingTop: 'max(env(safe-area-inset-top, 0px), 48px)' }}
    >
      <section className="mx-auto flex min-h-[calc(100vh-96px)] max-w-md flex-col items-center justify-center text-center">
        <div
          className="mb-5 flex h-14 w-14 items-center justify-center rounded-full"
          style={{ background: '#F0FDF4', color: '#16A34A' }}
        >
          <i className="ri-flask-line text-2xl" aria-hidden="true" />
        </div>
        <h1 className="text-xl font-bold text-gray-900">策略回测暂未开放</h1>
        <p className="mt-3 text-sm leading-6 text-gray-500">
          回测模块不在一期交付范围内，当前不提供回测入口、示例收益或可操作配置。
        </p>
      </section>
    </main>
  );
}
